import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { fmtErr } from "../lib/api";
import { useCaptcha, CaptchaField } from "../components/Captcha";
import { BookOpen } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const cap = useCaptcha();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const u = await login(email, password, cap.payload);
      navigate(u.role === "author" ? "/dashboard" : ["hd_admin", "hd_agent", "hd_user"].includes(u.role) ? "/desk" : "/admin");
    } catch (err) {
      setError(fmtErr(err));
      cap.refresh();
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-neutral-50 flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-2 font-bold text-xl font-heading text-neutral-900 mb-8">
          <BookOpen size={24} /> GloriPub
        </Link>
        <div className="bg-white border border-neutral-200 rounded-lg p-8 shadow-sm">
          <h1 className="text-2xl font-semibold font-heading text-neutral-900">Welcome back</h1>
          <p className="text-sm text-neutral-500 mt-1 mb-6">Log in to your publishing dashboard</p>
          {error && <div data-testid="login-error" className="text-red-700 bg-red-50 border border-red-200 rounded-md p-3 text-sm mb-4">{error}</div>}
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-sm font-medium text-neutral-700">Email</label>
              <input data-testid="login-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="mt-1 w-full bg-white border border-neutral-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-neutral-900 focus:border-neutral-900 outline-none" />
            </div>
            <div>
              <label className="text-sm font-medium text-neutral-700">Password</label>
              <input data-testid="login-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                className="mt-1 w-full bg-white border border-neutral-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-neutral-900 focus:border-neutral-900 outline-none" />
            </div>
            <CaptchaField {...cap} testId="login-captcha" />
            <button data-testid="login-submit-button" disabled={loading}
              className="w-full py-2.5 rounded-md text-white bg-neutral-900 hover:bg-neutral-800 font-medium text-sm transition-colors disabled:opacity-50">
              {loading ? "Logging in..." : "Log in"}
            </button>
          </form>
          <div className="flex justify-between mt-5 text-sm">
            <Link to="/forgot-password" data-testid="forgot-password-link" className="text-neutral-500 hover:text-neutral-900">Forgot password?</Link>
            <Link to="/register" data-testid="go-register-link" className="text-neutral-900 font-medium hover:underline">Create account</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
